import { render } from "./MyPopUpWindowHeaderButtonClose.vue?vue&type=template&id=3a6a04ef"
import script from "./MyPopUpWindowHeaderButtonClose.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindowHeaderButtonClose.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__